import React from 'react';

import { IPerformanceHeroFields } from '../../../types/contentful';

import { getImageData } from '../../utils/contentful';

import { Box } from '../Box';
import { BlockContainer, Column } from '../Layout';
import CtaWidget from '../CtaWidget';
import { VideoPlayer } from '../VideoPlayer';
import PrivacyPolicyDisclaimer from '../FullwidthHero/PrivacyPolicyDisclaimer';

import {
  ImageBox,
  PerformanceHeroImage,
  PerformanceHeroLayout,
  TextContainer,
  MobileCtaContainer,
  DesktopCtaContainer,
  HeaderText,
  SubheadText,
  SpacerColumn
} from './styles';

export function PerformanceHero({
  headingText,
  subheadingText,
  subheadingSize,
  mobileSubheadingSize,
  image,
  privacyPolicyDisclaimer,
  displayPrivacyPolicyIcon,
  desktopCta,
  mobileCta,
  videoModule
}: IPerformanceHeroFields) {
  return (
    <BlockContainer
      as="section"
      marginTop={{
        0: 'blockMarginY',
        tablet: 'blockMarginY_tablet'
      }}
      marginBottom={{
        0: 'blockMarginY',
        tablet: '3xl'
      }}
      revealOnScroll={false}
      data-blockid="performance-hero"
      data-testid="performance-hero"
    >
      <PerformanceHeroLayout>
        <Column size={{ 0: 12, tablet: 7, desktop: 6 }}>
          {videoModule?.fields?.vimeoId ? (
            <VideoPlayer {...videoModule?.fields} />
          ) : (
            <ImageBox flex="1">
              <PerformanceHeroImage
                {...getImageData(image)}
                heroImage={true}
                loading="eager"
              />
            </ImageBox>
          )}
        </Column>
        <TextContainer
          size={{ 0: 11, tablet: 5 }}
          flexDirection="column"
          justifyContent="center"
          marginTop={{ 0: 's', tablet: 0 }}
          margin={[0, 'auto']}
        >
          <HeaderText
            as="h1"
            fontSize={{ 0: 'h1_0', desktop: 'h1_tablet' }}
            marginBottom="m"
            data-testid="performance-hero-headline"
            dangerouslySetInnerHTML={{
              __html: headingText || ''
            }}
          />
          <SubheadText
            as="h2"
            data-testid="performance-hero-subhead"
            fontWeight="p"
            subheadingSize={subheadingSize || null}
            mobileSubheadingSize={mobileSubheadingSize || null}
            marginTop={0}
            marginBottom="ml"
          >
            {subheadingText}
          </SubheadText>
          {mobileCta && (
            <MobileCtaContainer>
              <CtaWidget
                {...mobileCta?.fields}
                sysId={mobileCta?.sys?.contentType?.sys?.id}
                id="mobile-nav-cta"
                module="Hero"
                isMobile={true}
              />
            </MobileCtaContainer>
          )}
          {desktopCta && (
            <DesktopCtaContainer>
              <CtaWidget
                {...desktopCta?.fields}
                sysId={desktopCta?.sys?.contentType?.sys?.id}
                id="desktop-nav-cta"
                module="Hero"
                height={56}
                isMobile={false}
              />
            </DesktopCtaContainer>
          )}
          {privacyPolicyDisclaimer && (
            <Box marginTop="ml">
              <PrivacyPolicyDisclaimer
                privacyPolicyDisclaimer={privacyPolicyDisclaimer}
                displayPrivacyPolicyIcon={displayPrivacyPolicyIcon}
              />
            </Box>
          )}
        </TextContainer>
        <SpacerColumn size={1} />
      </PerformanceHeroLayout>
    </BlockContainer>
  );
}
